import {faSearch} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  Button,
  ContentLayout,
  Content,
  InputBox,
  ListTable,
  SearchFilter,
  Img,
} from "@adminComponents";
import * as Datas from "@adminData";
import React, {useEffect, useState} from "react";
import {useSetRecoilState} from "recoil";
import {states} from "@recoils";
import {useAdminNav} from "@hook";
import {adminApi} from "@utils";
import styles from "./style.module.scss";
import {AdminScreenId} from "@assets";
import moment from "moment";
import _ from "lodash";

function getConvertUserData(data: any) {
  const result: {
    name?: string;
    email?: string;
    nickname?: string;
    phone?: string;
    birth?: string;
    gender?: string;
  } = {};

  try {
    if (data.kakao_account) {
      if (data.kakao_account.profile) {
        if (data.kakao_account.profile.nickname) {
          result.nickname = data.kakao_account.profile.nickname;
        }
      }
      if (data.kakao_account.email) {
        result.email = data.kakao_account.email;
      }
      if (data.kakao_account.name) {
        result.name = data.kakao_account.name;
      }
      if (data.kakao_account.birthyear || data.kakao_account.birthday) {
        result.birth = [
          data.kakao_account.birthyear || "YYYY",
          data.kakao_account.birthday || "MMDD",
        ].join();
      }
      if (data.kakao_account.gender) {
        result.gender = data.kakao_account.gender;
      }
      if (data.kakao_account.phone_number) {
        result.phone = data.kakao_account.phone_number;
      }
    }
    if (data.properties) {
      if (data.properties.nickname) {
        result.nickname = data.properties.nickname;
      }
    }
  } catch (error) {
    return result;
  }

  return result;
}

export default function Page() {
  const setAlertModal = useSetRecoilState(states.alertState);
  const {getParams, navigate} = useAdminNav();
  const {searchTxt: paramsSearchTxt, page: paramsPage = 1} = getParams<{
    searchTxt?: string;
    page?: number;
  }>();
  const [searchTxt, setSearchTxt] = useState(paramsSearchTxt);
  const [listData, setListData] =
    useState<Datas.ResultPagingResponse<Datas.IUser[]>>();

  async function getList({page = 1}: {page?: number} = {}) {
    try {
      const {data, success, message} = await adminApi.user.getList({
        page,
        searchTxt,
      });
      if (success) {
        setListData(data);
      } else {
        setAlertModal({
          isVisible: true,
          title: message || "오류가 발생했습니다",
        });
      }
    } catch (error) {
      console.error("getList error", error);
    }
  }

  async function confirmUser({no}: {no?: number}) {
    try {
      if (!no) {
        return;
      }
      if (!confirm("승인하시겠습니까?")) {
        return;
      }
      const {success, message} = await adminApi.user.confirm({no});
      alert(message);
      if (success) {
        getList({page: listData?.page?.cur || 1});
      }
    } catch (error) {
      console.error("confirmUser error", error);
    }
  }

  async function confirmResetUser({no}: {no?: number}) {
    try {
      if (!no) {
        return;
      }
      if (!confirm("승인취소하시겠습니까?")) {
        return;
      }
      const {success, message} = await adminApi.user.confirmReset({no});
      alert(message);
      if (success) {
        getList({page: listData?.page?.cur || 1});
      }
    } catch (error) {
      console.error("confirmUser error", error);
    }
  }

  function goToListPage(params: {searchTxt?: string; page?: number}) {
    navigate({
      url: AdminScreenId.USER,
      params,
    });
  }

  useEffect(() => {
    getList({page: paramsPage});
  }, [location.search]);

  return (
    <div className={styles.container}>
      <ContentLayout title={"회원가입 승인"}>
        <SearchFilter
          left={[
            <InputBox
              key={1}
              value={searchTxt}
              onValue={setSearchTxt}
              onEnter={() => {
                goToListPage({page: 1, searchTxt});
              }}
              rightContent={
                <div
                  style={{display: "flex"}}
                  onClick={() => {
                    goToListPage({page: 1, searchTxt});
                  }}>
                  <FontAwesomeIcon icon={faSearch} />
                </div>
              }
            />,
          ]}
        />
        <Content>
          <>
            <ListTable
              paging={listData?.page}
              getList={({page: newPage}) => {
                goToListPage({
                  page: newPage,
                  searchTxt,
                });
              }}>
              <thead>
                <tr>
                  <th>번호</th>
                  <th>sns</th>
                  <th>정보</th>
                  <th>승인여부</th>
                  <th>가입일</th>
                </tr>
              </thead>
              <tbody>
                {(listData?.result || []).length === 0 ? (
                  <tr>
                    <td colSpan={5}>조회된 내용이 없습니다.</td>
                  </tr>
                ) : (
                  <>
                    {(listData?.result || []).map(item => {
                      const userData = getConvertUserData(item.user_data);
                      return (
                        <tr key={`${item.no}_${item.confirm}`}>
                          <td>{item.no}</td>
                          <td>{item.sns_type}</td>
                          <td>
                            <table className={styles.infoTable}>
                              {!!userData.name && (
                                <tr>
                                  <td>이름:</td>
                                  <td>{userData.name}</td>
                                </tr>
                              )}
                              {!!userData.email && (
                                <tr>
                                  <td>이메일:</td>
                                  <td>{userData.email}</td>
                                </tr>
                              )}
                              {!!userData.nickname && (
                                <tr>
                                  <td>닉네임:</td>
                                  <td>{userData.nickname}</td>
                                </tr>
                              )}
                              {!!userData.gender && (
                                <tr>
                                  <td>성별:</td>
                                  <td>{userData.gender}</td>
                                </tr>
                              )}
                              {!!userData.birth && (
                                <tr>
                                  <td>생년월일:</td>
                                  <td>{userData.birth}</td>
                                </tr>
                              )}
                              {!!userData.phone && (
                                <tr>
                                  <td>전화번호:</td>
                                  <td>{userData.phone}</td>
                                </tr>
                              )}
                            </table>
                          </td>
                          <td>
                            {item.confirm === "1" ? (
                              <button
                                className={styles.resetBtn}
                                onClick={() => confirmResetUser({no: item.no})}>
                                승인취소
                              </button>
                            ) : (
                              <button
                                className={styles.confirmBtn}
                                onClick={() => confirmUser({no: item.no})}>
                                승인하기
                              </button>
                            )}
                          </td>
                          <td>
                            {moment(item.created_at).format("YYYY-MM-DD")}
                          </td>
                        </tr>
                      );
                    })}
                  </>
                )}
              </tbody>
            </ListTable>
          </>
        </Content>
      </ContentLayout>
    </div>
  );
}
